import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getSmasterTransactionDetail=(date)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_SM_TRANSACTION_DETAIL_START
    })
    await axios.get(`/transactions/${date}`)
                .then(response=>dispatch({
                    type:actionTypes.GET_SM_TRANSACTION_DETAIL_SUCCESS,
                    payload:response.data
                }))
                .catch(error=>dispatch({
                    type:actionTypes.GET_SM_TRANSACTION_DETAIL_FAIL,
                    payload:getMessage(error)
                }))
}